package ru.playa.sce.dto

data class WayPoint(
        val id: Int = 0,
        val point: Point,
        val country: Option? = null,
        val town: Option? = null
)